import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class AsstesService {

  constructor(
    private _http : HttpClient,
    private _capEngineService: CapabilityEngineService,    
  ) { }

  getAssets(){
    let header = this._capEngineService.getHeaders('viewTaskTemplateList');
    return this._http.get(environment.serverUrl + '/assets/',header );
  };
  saveAsset(assetObj){
    let header = this._capEngineService.getHeaders('viewTaskTemplateList');
    return this._http.post(environment.serverUrl + '/assets/' , assetObj , header);
  }
  renameAsset(obj){
    let header = this._capEngineService.getHeaders('viewTaskTemplateList');
    return this._http.put(environment.serverUrl + '/assets/', obj, header );
  }
  deleteAsset(assetId){
    let header = this._capEngineService.getHeaders('viewTaskTemplateList');
    return this._http.delete(environment.serverUrl + '/assets/assetId/' +  assetId , header);
  }
}



// WEBPACK FOOTER //
// ./src/app/assets/asstes.service.ts